import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import MaterialDashboardPage from '../../../components/Library/pages/performance';

import { ModulePermissionProps } from '../../../../../common/module/types';

export const SystemConfig = {
  blockName: 'component.formTitle.promotion-material',
  blockType: 'promotionMaterialPerformance',
  moduleType: 'Promotion',
};

const PerformancePage: FC<RouteComponentProps & ModulePermissionProps> = (props) => {
  return <MaterialDashboardPage {...props} {...SystemConfig} />;
};

export default PerformancePage;
